import { ExclamationCircleIcon } from "@heroicons/react/outline";
import { FormEvent, useEffect, useState } from "react";
import useStore from "../store/store";
import dialogPolyfill from "../utils/diaglog-polyfill";

type NotInPlanningModalPropsType = {
  employeeName: string;
};

const NotInPlanningModal = ({ employeeName }: NotInPlanningModalPropsType) => {
  useEffect(() => {
    var dialog = document.querySelector("#notInPlanning");
    //@ts-ignore
    dialogPolyfill.registerDialog(dialog);
  }, []);

  return (
    <dialog
      id="notInPlanning"
      className="border-none rounded-xl py-5 px-10 min-w-[500px] fixed left-0 top-0 mt-0"
    >
      <div className="flex items-center w-full justify-between">
        <h3 className="uppercase font-bold">
          Medewerker staat niet in de planning
        </h3>
        <button
          className="text-3xl"
          onClick={() => {
            //@ts-ignore
            document.getElementById("notInPlanning")?.close();
          }}
          type="reset"
        >
          &times;
        </button>
      </div>

      <div className="flex justify-center items-center flex-col">
        <ExclamationCircleIcon className="text-red h-64 mt-7"></ExclamationCircleIcon>
        <p className="text-center text-blue mt-7">
          <span className="font-bold">{employeeName}</span> staat niet in de
          planning of werd niet bevestigd.
        </p>
        <p className="text-center text-blue">
          Contacteer Digital Payroll Services om deze actie uit te voeren.
        </p>

        <div className="w-full flex justify-center items-center mt-7">
          <div className="bg-grey p-2 rounded-lg w-36">
            <p className="text-blue font-bold text-center text-sm">
              Tel. 051 46 58 16
            </p>
          </div>
        </div>
      </div>
    </dialog>
  );
};

export default NotInPlanningModal;
